<template>
  <SimpleButton
    size="sm"
    class="w-8! px-0! border-red/35! bg-red-soft! text-red!
           hover:bg-red! hover:border-red! hover:text-on-red!"
    :title="$t('ui.close_button_title')"
    @click="emit('click')"
  >
    <IconXMark16Solid class="size-4 shrink-0" />
  </SimpleButton>
</template>

<script setup>
import { IconXMark16Solid } from '@iconify-prerendered/vue-heroicons';
import { inject, onMounted, onUnmounted } from 'vue';


const props = defineProps({
  allowCloseOnEsc: {
    type: Function,
    default: null,
  },
});
const emit = defineEmits(['click']);
const isEditComment = inject('isEditComment', false);
const lastCommentEditClosedAt = inject('lastCommentEditClosedAt', 0);

function handleEscapeKey(event) {
  if (event.key === 'Escape' && (!props.allowCloseOnEsc || props.allowCloseOnEsc(event))) {
    if (event.repeat) return;
    if (Date.now() - lastCommentEditClosedAt.value < 250) return;
    if (!isEditComment.value) {
      emit('click');
    }
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleEscapeKey);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleEscapeKey);
});
</script>